/// <reference types="@angular/localize" />

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
  inject,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import posthog from 'posthog-js';

import { environment } from '~env/environment';
import { AuthService } from '~features/auth/auth.service';
import { JwtInterceptor } from '~features/auth/jwt.interceptor';
import { LoadingInterceptor } from '~shared/interceptors/loading.interceptor';

import { AppRouting } from './app/app-routing';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
} else {
  console.log('[Dev] Leeway API disabled:', environment.disableLeewayApi);
}

// Only initialize PostHog if not running on localhost
if (!window.location.hostname.includes('localhost') && !window.location.hostname.includes('127.0.0.1')) {
  posthog.init('phc_MxLl1fFRxZwyuIDNTU6k9mHelt0oaPUSzLlepbVnodZ', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'identified_only', // "identified_only" for anonymous until user profile is set up or "always" for everyone, "never" for
    capture_pageview: false,
    capture_pageleave: true,
    //secure_cookie: true,
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      AppRouting,
      FormsModule,
      ReactiveFormsModule,
      // Only initialize Google Analytics if not running on localhost
      ...(window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1')
        ? []
        : [
            NgxGoogleAnalyticsModule.forRoot('G-CDCMZ9EJSM', [
              {
                command: 'consent',
                values: [
                  'default',
                  {
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                  },
                ],
              },
            ]),
          ])
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(AuthService).loadToken()),
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
}).catch((err) => console.error(err));
